export const COOKIES_NAME = 'clpHeaderFirstName';
export const COOKIES_ROLE = 'clpHeaderRole';
